import { popupDialogModel } from "@/core/popup-dialog/popup-dialog.model";
import { getAuthRedirectService } from "@/core/services/auth-redirects.service";
import { Directive } from "vue";
import { sessionModel } from "@/shared/state/session.model";

function parseHref(href: string) {
    if (!href) {
        return undefined;
    }

    const url = new URL(href);
    return url.pathname + url.search;
}

type AppAuthRequiredOptionsRole = "dealer" | "supplier";

function showLoginPopup(event: UIEvent) {
    if (sessionModel.sessionDto.value) {
        return;
    }
    event.preventDefault();
    event.stopPropagation();

    const text =
        "Lorem ipsum dolor sit amet, consecte tur adipiscing elit. Aliquam at parttitor sem, Aliquam erat volutpat.";
    popupDialogModel.showLoginPopup(text);
}

function handleClick(
    event: UIEvent,
    role?: AppAuthRequiredOptionsRole,
    redirectUrl?: string,
) {
    if (sessionModel.sessionDto.value) {
        return;
    }
    event.preventDefault();
    event.stopPropagation();

    getAuthRedirectService().cancelLoginUrl = parseHref(window.location.href) || "/";
    if (redirectUrl) {
        getAuthRedirectService().afterLoginUrl = redirectUrl;
    }

    showLoginPopup(event);
}

type AppAuthRequiredOptions =
    | {
          role: AppAuthRequiredOptionsRole;
          redirectUrl?: string;
          showLogin?: boolean;
          disable?: boolean;
      }
    | undefined;

type AppAuthRequiredElement = HTMLElement & {
    _appAuthRequiredDispose?: () => void;
    _appAuthRequiredOptions?: AppAuthRequiredOptions;
};

export const appAuthRequired: Directive<AppAuthRequiredElement, AppAuthRequiredOptions> =
    {
        mounted(el, bindings) {
            el._appAuthRequiredOptions = bindings.value;

            const handle = (event: UIEvent) => {
                const role = el._appAuthRequiredOptions?.role;
                const showLogin = el._appAuthRequiredOptions?.showLogin;
                const disable = el._appAuthRequiredOptions?.disable;

                if (disable) {
                    return;
                }

                if (showLogin) {
                    showLoginPopup(event);
                    return;
                }

                const redirectUrl =
                    el._appAuthRequiredOptions?.redirectUrl ||
                    parseHref(
                        (el instanceof HTMLAnchorElement && el.href) ||
                            window.location.href,
                    );

                handleClick(event, role, redirectUrl);
            };

            el.addEventListener("pointerdown", handle, true);
            el.addEventListener("click", handle, true);

            el._appAuthRequiredDispose = () => {
                el.removeEventListener("pointerdown", handle, true);
                el.removeEventListener("click", handle, true);
            };
        },
        unmounted(el) {
            if (el._appAuthRequiredDispose) {
                el._appAuthRequiredDispose();
            }
        },
        updated(el, bindings) {
            el._appAuthRequiredOptions = bindings.value;
        },
    };
